import { render } from "./AboutCard.vue?vue&type=template&id=fa9b2d38"
import script from "./AboutCard.vue?vue&type=script&lang=js"
export * from "./AboutCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__